import { useEffect, useState } from "react";

// 제휴 결제 할인(챌린저/마스터 -30,000)의 활성 여부 + 남은 시간을 라이브로 계산.
// expiresAtMs(epoch millis)는 백엔드가 결제페이지 최초 진입 기준 24h + 어트리뷰션 윈도우(마지막 제휴 진입 후 3일) 중
// 먼저 끝나는 쪽으로 eligibility 판정 후 order/detail 로 내려준다(없으면 비활성 — 어트리뷰션 만료 = 오가닉 취급 포함).
// 남은 시간은 1시간 단위로 올림: 23시간 30분 → 24, 1초 → 1.
export default function useReferralDiscount(
  expiresAtMs: number | null | undefined
) {
  // 표시는 시간 단위(올림)라 60초 틱이면 충분 (큰 결제 페이지를 매초 리렌더하지 않도록).
  const [now, setNow] = useState(() => Date.now());
  useEffect(() => {
    if (!expiresAtMs) return;
    const id = setInterval(() => setNow(Date.now()), 60000);
    return () => clearInterval(id);
  }, [expiresAtMs]);

  const remainingMs = expiresAtMs ? expiresAtMs - now : 0;
  const active = !!expiresAtMs && remainingMs > 0;
  // 윈도우는 24h. 클라이언트 시계가 서버보다 뒤지면 remainingMs 가 24h 를 미세 초과해
  // ceil 이 25 가 될 수 있으므로 24 로 캡(표시 상한).
  const hoursLeft = active ? Math.min(24, Math.ceil(remainingMs / 3600000)) : 0;

  return { active, hoursLeft };
}
